import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { YouTubeService } from '../../services/you-tube.service';
import { Video } from '../../classes/video';
import { DomSanitizer } from '@angular/platform-browser';
import { Sanitizer } from '@angular/core/src/security';
import { ApplicationRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

declare var jQuery: any;

@Component({
  selector: 'app-video-list',
  templateUrl: './video-list.component.html',
  styleUrls: ['./video-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class VideoListComponent implements OnInit {

  @ViewChild('music_book') musicBook;
  @ViewChild('fairy_finds_book') fairyFindsBook;
  @ViewChild('stories_book') storiesBook;
  public videos;

  constructor(private route: ActivatedRoute,
              private youtubeService: YouTubeService,
              private sanitizer: DomSanitizer,
              private app: ApplicationRef) {

  }

  ngOnInit() {
    this.videos = [];
    this.route.data.subscribe((data: { videoData: any }) => {
      data.videoData['items'].forEach(element => {
        const snippet = element['snippet'];
        this.videos.push(
          new Video(snippet['resourceId']['videoId'],
            snippet['title'], snippet['description'],
            snippet['thumbnails']['standard']['url'],
            this.sanitizer)
        );
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/video-list/video-list.component.ts